import React, { useEffect } from 'react'
import getPlacePermissions from '../services/getPlacePermissions'

export const USER_STATUS = {
  SUPER_ADMIN: 'super',
  NOT_AUTHORIZED: 'not-authorized',
  LOADING: 'loading',
  ERROR: 'error',
} as const

type UserStatus = (typeof USER_STATUS)[keyof typeof USER_STATUS]

export default function useUserAdminRoleStatus(): UserStatus {
  const [userStatus, setUserStatus] = React.useState<UserStatus>('loading')

  useEffect(() => {
    getPlacePermissions()
      .then((permissions) => {
        if ('err' in permissions) {
          setUserStatus(USER_STATUS.ERROR)
        } else if (permissions?.PERM_PLACES_ADMIN_APP) {
          setUserStatus(USER_STATUS.SUPER_ADMIN)
        } else {
          setUserStatus(USER_STATUS.NOT_AUTHORIZED)
        }
      })
      .catch(() => {
        setUserStatus(USER_STATUS.ERROR)
      })
  }, [])

  return userStatus
}
